export default __webpack_public_path__ + "static/media/rain.171ea451.png";